import { Typography } from '@/components/common';
import Image from 'next/image';

export const ClientBg: React.FC = () => {
	return (
		<BgImage>
			<div className="max-w-[480px] flex flex-col m-auto justify-center items-center w-full h-full">
				<div className="block relative">
					<p className="text-[40px] text-black font-bold text-center tracking-tight leading-10">
						Your <span className="text-primary">Legal Journey</span> Made Easy
					</p>
				</div>
				<div className="flex items-center justify-center gap-2 mt-6 relative">
					<Typography type="regular-20" className="text-center">
						Fast. Easy. No Upfront Cost with{' '}
					</Typography>
					<Image
						src="/logos/logo.webp"
						alt="claim magic logo"
						width={148}
						height={27}
					/>
					<Image
						className="absolute -right-[8.2rem] -top-[14.6rem]"
						src="/img/dashboard/wizar-stars.webp"
						alt="wizar"
						height={200}
						width={220}
						priority
					/>
				</div>
			</div>
		</BgImage>
	);
};

const BgImage = ({ children }: { children: React.ReactNode }) => {
	return (
		<div className="relative w-full h-full overflow-hidden">
			<Image
				src={'/img/dashboard/authLayout.webp'}
				alt="Background"
				fill
				className="object-cover"
			/>
			{children}
		</div>
	);
};
